import {
  AppLanguages,
  AssetType,
  PaymentMethodTypeEnum,
  TransactionType,
  CurrencyCode,
} from 'interfaces'
import HEYTRADE_CONFIG from './heytrade/config'
import TBCC_CONFIG from './tbcc/config'
import UNICREDIT_CONFIG from './unicredit-pl/config'
import BIT2ME_CONFIG from './bit2me/config'
import { BrokerTierConstants } from '@interfaces/brokerTierConstants'

export type AvailableBusiness = 'heytrade' | 'tbcc' | 'unicredit-pl' | 'bit2me' // example values

export interface ScreenConfig {
  enabled: boolean
}

export interface AppFeaturesConfig {
  info: {
    longName: string
    shortName: string
  }
  resources: {
    favicon: string
    logo: string
    navbarLogo: string
    loginLogo: string
    qrCode: string
    pushNotificationLogo: string
  }
  styles: string[]
  tradingView: {
    advancedChartColorsConfig: { [key: string]: Record<string, string> }
    simpleChartColorsConfig: { [key: string]: Record<string, string> }
    customCss: string
  }
  i18n: {
    languages: AppLanguages[]
    resourcesUrls: Partial<Record<AppLanguages, string>>
  }
  screens: {
    companyDetail: {
      showAnalystRatings: boolean
      showEarnings: boolean
      showBullBearsSay: boolean
      showNews: boolean
    }
    profile?: {
      screens?: {
        help: {
          showHelp?: boolean
          showChat?: boolean
        } | null
      }
    }
  }
  features: {
    allowStockDistributionChart: boolean
    allowExtendedHoursTrading: boolean
    allowSignUp: boolean
    allowFinny: boolean
    assetsAllowed: AssetType[]
    transactionsAllowed: TransactionType[]
    paymentMethods: {
      topup: {
        type: PaymentMethodTypeEnum
        addPaymentMethod: boolean
        allowAsDefault: boolean
      }[]
      cashout: {
        type: PaymentMethodTypeEnum
        addPaymentMethod: boolean
        allowAsDefault: boolean
      }[]
    }
    orders: {
      allowMarketOrders: boolean
      allowLimitOrders: boolean
      limitOrdersWhenMarketIsClosed: boolean
      allowStopLossAndTakeProfit: boolean
    }
    portfolioTransfer: boolean
    recurringPayments: boolean
  }
  constants?: {
    brokerTiers?: BrokerTierConstants
    privacyPolicyUrls: Record<AppLanguages, string> | null
    faqsUrls: Record<AppLanguages, string> | null
    securityUrls: Record<AppLanguages, string> | null
    termsAndConditions?: string
    supportEmail?: string
    truelayer?: {
      privacyPolicyUrl?: Record<AppLanguages, string>
      termsAndConditions?: Record<AppLanguages, string>
    }
    portfolioTransferInfoUrls: Record<AppLanguages, string> | null
    defaultLang: string
    defaultCurrency: CurrencyCode
    minimumTopUpQuantityRequired: boolean
  }
  // TBD Move to env variable
  infra: {
    sentryDSN: string
    localStorageKey: string
  }
}

export type AppFeatures = {
  [key in AvailableBusiness]: AppFeaturesConfig
}

export const APP_FEATURES: AppFeatures = {
  heytrade: HEYTRADE_CONFIG,
  tbcc: TBCC_CONFIG,
  'unicredit-pl': UNICREDIT_CONFIG,
  bit2me: BIT2ME_CONFIG,
}
